import styles from "./CandyStripe.module.scss";
import { useHomeContextIsExploreReady } from "../homeContext.ts";
import { useBrandLoaderData } from "../../root/rootLoader.ts";
import { clsx } from "clsx";

export default function CandyStripe() {
  const brand = useBrandLoaderData();
  const exploreReady = useHomeContextIsExploreReady();

  if (!brand.Explore.enabled || exploreReady) {
    return null;
  }

  return <div className={clsx("vst-candystripe", styles.candystripe)}></div>;
}
